import { apiClient } from './apiClient';
import { DashboardStats, RecentActivity, UpcomingInterview, StageStats } from '../../types/types';

export const getDashboardData = async () => {
    const response = await apiClient.get('/dashboard');
    return response.data;
};

export const getDashboardStats = async (): Promise<DashboardStats> => {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
};

export const getRecentActivities = async (count = 10): Promise<RecentActivity[]> => {
    const response = await apiClient.get(`/dashboard/recent-activities`, {
        params: { count }
    });
    return response.data;
};

export const getUpcomingInterviews = async (days = 7): Promise<UpcomingInterview[]> => {
    const response = await apiClient.get(`/dashboard/upcoming-interviews`, {
        params: { days }
    });
    return response.data;
};

export const getStageStats = async (): Promise<StageStats[]> => {
    const response = await apiClient.get('/dashboard/stage-stats');
    return response.data;
};